<template>
<el-dialog :title="viewFlag === 'view' ? '查看' :  !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="55%" :visible.sync="viewData.visible">
    <!-- <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1> -->
    <H3 style="text-align:center">{{dataForm.projectName}}</H3>
    <!-- 价格协议支付标准 姜丽丽联系 QA 报价的时候 -->
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <el-tabs>
            <el-tab-pane key="1" label="基础信息" class="tab_style">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <el-descriptions-item label="合同编码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="contractCode" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.contractCode}}</span>
                                <el-input v-else v-model="dataForm.contractCode" placeholder="合同编码" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同名称:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="contractName" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.contractName}}</span>
                                <el-input v-else v-model="dataForm.contractName" placeholder="合同名称" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同类型:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="contractType" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{getCONTRACT_TYPE_VALUE(dataForm.contractType)}}</span>
                                <el-select v-else v-model="dataForm.contractType" placeholder="请选择" clearable>
                                    <el-option v-for="item in CONTRACT_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同状态:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="contractStatus" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{getCONTRACT_STATUS_VALUE(dataForm.contractStatus)}}</span>
                                <el-select v-else v-model="dataForm.contractStatus" placeholder="请选择" clearable>
                                    <el-option v-for="item in CONTRACT_STATUS_VALUE" :key="item.value" :label="item.label" :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="甲方:" :label-style="getStyle()" :content-style="getStyle2()">
                            <!-- 甲方采购组织 -->
                            <el-form-item prop="purchasePartya" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.purchasePartya}}</span>
                                <!-- <el-input v-else v-model="dataForm.purchasePartya" placeholder="甲方" clearable></el-input> -->
                                <el-select v-else v-model="dataForm.purchasePartya" filterable placeholder="请选择组织">
                                    <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.orgName" :value="item.orgCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="乙方:" :label-style="getStyle()" :content-style="getStyle2()">
                            <!-- 供应商 -->
                            <el-form-item prop="supplierPartyb" style="margin-bottom: 0" size="small">
                                <span>{{dataForm.supplierPartyb}}</span>&nbsp;&nbsp;
                                <!-- <el-input v-else v-model="dataForm.supplierPartyb" placeholder="乙方" clearable></el-input> -->
                                <el-button size="small" plain type="primary" @click="chooseSupplier()">
                                    选择
                                </el-button>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="甲方代表:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="partyaRepresentive" style="margin-bottom: 0" size="small">
                                <!-- 采购组 -->
                                <span>{{dataForm.partyaRepresentive}}</span>&nbsp;&nbsp;
                                <!-- <el-input v-else v-model="dataForm.partyaRepresentive" placeholder="甲方代表"></el-input> -->
                                <el-button v-if="viewFlag !== 'view'" size="small" plain type="primary" @click="choosePartyaRepresentive()">
                                    选择
                                </el-button>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="乙方代表:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="partybRepresentive" style="margin-bottom: 0" size="small">
                                <!-- 供应商代表 -->
                                <span>{{dataForm.partybRepresentive}}</span>
                                <!-- <el-input v-else v-model="dataForm.partybRepresentive" placeholder="乙方代表"></el-input> -->
                                <!-- <el-button v-else size="small" plain type="primary" @click="choosePartybRepresentive">
                                    选择乙方代表
                                </el-button> -->
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="甲方签订日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="partyaSignDate" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.partyaSignDate}}</span>
                                <el-date-picker v-model="dataForm.partyaSignDate" value-format="yyyy-MM-dd HH:mm:ss" v-else type="date" placeholder="甲方签订日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="乙方签订日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="partybSignDate" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.partybSignDate}}</span>
                                <el-date-picker v-model="dataForm.partybSignDate" value-format="yyyy-MM-dd HH:mm:ss" v-else type="date" placeholder="乙方签订日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="合同有效期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="validityOfContract" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dateFormatValue(dataForm.contractStartDate)}}-{{dateFormatValue(dataForm.contractEndDate)}}</span>
                                <el-date-picker v-else v-model="validityOfContract" style="width: 295px" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item></el-descriptions-item>
                        <el-descriptions-item label="备注:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="note" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.note}}</span>
                                <el-input v-else type="textarea" v-model="dataForm.note" :max="999" :rows="3" placeholder="备注"></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                      <el-descriptions-item label="子公司:" :label-style="getStyle()" :content-style="getStyle2()">
                      <el-form-item  prop="subcompanyId" style="margin-bottom: 0" size="small">
                        <el-select  v-model="dataForm.subcompanyId" @change="getSupCompanyList" class="input-width">
                          <el-option
                              v-for="item in supCompanyList"
                              :key="item.id"
                              :label="item.orgName"
                              :value="item.id"
                          >
                          </el-option>
                        </el-select>
                        <div v-if="viewFlag === 'view' && selectedSubcompanyName" class="selected-subcompany-names">
                          {{ selectedSubcompanyName }}
                        </div>
                      </el-form-item>
                      </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane :key="2" label="附件文件" class="tab_style">
                <!-- TODO:上传下载 产看 需求文档 -->
                <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
            </el-tab-pane>
        </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <el-button v-if="viewFlag !== 'view'" size="small" plain type="primary" @click="dataFormSubmit()" :loading="loading">
            保存
        </el-button>
    </span>
    <!-- TODO: 选择合格供应商 -->
    <supplier-select-dialog ref="supplierSelectDialog"></supplier-select-dialog>
    <!-- TODO: 选择甲方代表 -->
    <common-user-dialog ref="commonUserDialog"></common-user-dialog>
</el-dialog>
</template>

<script>
import {
    getContractById,
    editContract,
    createContract
} from '@/controller/contract'
import {
    getPurchaseOrgList
} from "@/controller/systemData"
import {
    CONTRACT_TYPE_VALUE,
    getCONTRACT_TYPE_VALUE,
    CONTRACT_STATUS_VALUE,
    getCONTRACT_STATUS_VALUE,
    DIALOG_CLOSED_TYPE,
    USER_TYPE
} from '@/utils/const'
import moment from 'moment'
import CommonUserDialog from "@/views/common/common-user-dialog";
import FilesUpDown from "@/views/common/file-up-down";
import {
    setLoading
} from "@/utils/index";
import supplierSelectDialog from "./supplier-select-dialog";
import {
    mapping
} from "@/utils";
import {supCompanyList} from "../../../../controller/sys";
import {getCurrentUserPurOrg} from "../../../../controller/contract";
// require('@/mock/mockContract');
export default {
    components: {
        FilesUpDown, //上传附件
        supplierSelectDialog,
        CommonUserDialog
    },
    data() {
        let checkData = (rule, value, callback) => {
            console.log('checkData...')
            if (!value) {
                this.loading = false
                return callback(new Error(rule.message))
            } else if (value.length == 1 && !value[0]) {
                this.loading = false
                callback(new Error(rule.message));
            } else {
                callback();
            };
        }
        return {
            FILE_BIZ_TYPE: 7,
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            CONTRACT_TYPE_VALUE: CONTRACT_TYPE_VALUE,
            getCONTRACT_TYPE_VALUE: getCONTRACT_TYPE_VALUE,
            CONTRACT_STATUS_VALUE: CONTRACT_STATUS_VALUE,
            getCONTRACT_STATUS_VALUE: getCONTRACT_STATUS_VALUE,
            dataList: [],
            validityOfContract: [],
            purchaseOrgList: [],
            supplierSelectDialogVisible: false,
            dataForm: {
                id: '',
                purchasePartya: '',
                supplierPartyb: '',
                contractCode: '',
                contractType: '',
                contractStatus: '',
                contractName: '',
                attchmentId: '',
                partyaRepresentive: '',
                partyaSignDate: '',
                partybRepresentive: '',
                partybSignDate: '',
                note: '',
                contractStartDate: '',
                contractEndDate: '',
                subcompanyId:''
            },
            dataRule: {
                contractCode: [{
                    required: true,
                    message: '合同编码不能为空',
                    trigger: 'blur'
                }],
                contractName: [{
                    required: true,
                    message: '合同名称不能为空',
                    trigger: 'blur'
                }],
                contractType: [{
                    required: true,
                    message: '合同类型不能为空',
                    trigger: 'blur'
                }],
                contractStatus: [{
                    required: true,
                    message: '合同状态不能为空',
                    trigger: 'blur'
                }],
                purchasePartya: [{
                    required: true,
                    message: '甲方不能为空',
                    trigger: 'blur'
                }],
                partyaRepresentive: [{
                    required: true,
                    message: '甲方代表不能为空',
                    trigger: 'blur'
                }],
                supplierPartyb: [{
                    required: true,
                    message: '乙方不能为空',
                    trigger: 'blur'
                }],
                partybRepresentive: [{
                    required: true,
                    message: '乙方代表不能为空',
                    trigger: 'blur'
                }],
                partyaSignDate: [{
                    required: true,
                    message: '甲方签订日期不能为空',
                    trigger: 'blur'
                }],
                partybSignDate: [{
                    required: true,
                    message: '乙方签订日期不能为空',
                    trigger: 'blur'
                }],
                /*validityOfContract: [{
                    message: "请选择时间段",
                    trigger: 'change',
                    validator: checkData
                }]*/
            },
            supCompanyList: [] ,// 子公司列表
            subcompanyMap: {} // 子公司ID到名称的映射
        }
    },
   computed: {
    // 计算选中的子公司名称
    selectedSubcompanyName() {
      if (!this.dataForm.subcompanyId) {
        return '';
      }

      return this.subcompanyMap[this.dataForm.subcompanyId] || `未知组织(${this.dataForm.subcompanyId})`;
    }
  },
    mounted() {
      this.getSupCompanyList();
    },
    methods: {
        init(data, id, viewFlag) {
            console.log(id)
            // this.dataForm = data ? data : this.dataForm
            this.viewFlag = viewFlag
            debugger
            this.dataForm.id = id || 0
            this.validityOfContract = ''
            this.viewData.visible = true
            this.loading = false
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FilesUpDown.init(viewFlag);
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getContractById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm.purchasePartya = data.body.purchasePartya
                            this.dataForm.supplierPartyb = data.body.supplierPartyb
                            this.dataForm.contractCode = data.body.contractCode
                            this.dataForm.contractType = data.body.contractType
                            this.dataForm.contractStatus = data.body.contractStatus
                            this.dataForm.contractName = data.body.contractName
                            this.dataForm.attchmentId = data.body.attchmentId
                            this.dataForm.partyaRepresentive = data.body.partyaRepresentive
                            this.dataForm.partyaSignDate = data.body.partyaSignDate
                            this.dataForm.partybRepresentive = data.body.partybRepresentive
                            this.dataForm.partybSignDate = data.body.partybSignDate
                            this.dataForm.partybCode = data.body.partybCode
                            this.dataForm.note = data.body.note
                            this.validityOfContract = []
                            if (data.body.contractStartDate) {
                                this.dataForm.contractStartDate = data.body.contractStartDate
                                this.validityOfContract.push(data.body.contractStartDate)
                            }
                            if (data.body.contractEndDate) {
                                this.dataForm.contractEndDate = data.body.contractEndDate
                                this.validityOfContract.push(data.body.contractEndDate)
                            }
                            if (!data.body.contractStartDate || !data.body.contractEndDate) {
                                this.validityOfContract = ''
                            }
                          // 初始化子公司ID（单个值）
                          this.dataForm.subcompanyId = data.body.subcompanyId || null;

                          // 同步更新显示名称
                          this.updateSubcompanyMap();
                        }
                    })
                }
                this.getPurchaseOrgList()
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    setLoading()
                    // this.dataForm.contractCode = '9999'
                    debugger
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'purchasePartya': this.dataForm.purchasePartya,
                        'supplierPartyb': this.dataForm.supplierPartyb,
                        'contractCode': this.dataForm.contractCode,
                        'contractType': this.dataForm.contractType,
                        'contractStatus': this.dataForm.contractStatus,
                        'contractName': this.dataForm.contractName,
                        'attchmentId': this.dataForm.attchmentId,
                        'partyaRepresentive': this.dataForm.partyaRepresentive,
                        'partyaSignDate': this.dataForm.partyaSignDate,
                        'partybRepresentive': this.dataForm.partybRepresentive,
                        'partybSignDate': this.dataForm.partybSignDate,
                        'partybCode': this.dataForm.partybCode,
                        'note': this.dataForm.note,
                        'subcompanyId':this.dataForm.subcompanyId,
                        'contractStartDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[0] : null,
                        'contractEndDate': this.validityOfContract && this.validityOfContract.length === 2 ? this.validityOfContract[1] : null
                    }
                    if (this.dataForm.id) {
                        editContract(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.loading = false
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.loading = false
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createContract(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.loading = false
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.loading = false
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        // 下拉输入采购组织
        getPurchaseOrgList() {
          getCurrentUserPurOrg({
                purchaseOrgCode: "",
                purchaseOrgName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.purchaseOrgList = data.body;
                }
            });
        },
        chooseSupplier() {
            this.$refs.supplierSelectDialog.open();
            this.$refs.supplierSelectDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    this.dataForm.partybCode = payload.data.venderCode
                    this.dataForm.supplierPartyb = payload.data.venderName
                    this.dataForm.partybRepresentive = payload.data.venderContacts
                }
            };
        },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
            this.updateSubcompanyMap(); // 更新ID到名称的映射
            // 处理子公司选择逻辑
            this.handleSubcompanySelection();
          }
        })
      },
      // 更新子公司ID到名称的映射
      updateSubcompanyMap() {
        this.subcompanyMap = {};
        this.supCompanyList.forEach(item => {
          this.subcompanyMap[item.id] = item.orgName;
        });
      },
      // 处理子公司选择逻辑
      handleSubcompanySelection() {
        // 如果已有选中的子公司，不做处理
        if (this.dataForm.subcompanyId && this.dataForm.subcompanyId.length > 0) {
          return;
        }
        // 如果子公司列表只有一条，自动选中
        if (this.supCompanyList && this.supCompanyList.length === 1) {
          this.dataForm.subcompanyId = this.supCompanyList[0].id;
        }
      },
      // 子公司选择变化处理
      handleSubcompanyChange() {
        // 确保映射关系最新
        this.updateSubcompanyMap();
      },
        choosePartyaRepresentive() {
            this.$refs.commonUserDialog.open(USER_TYPE.PERCHASE)
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // TODO: 岗位ID
                    this.dataForm.partyaRepresentive = payload.data.realName
                }
            };
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 314.4px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.tab_style {
    min-height: 45vh;
}
</style>
